import { render, staticRenderFns } from "./swiper-button.vue?vue&type=template&id=ca58a3a6&scoped=true&"
import script from "./swiper-button.vue?vue&type=script&lang=js&"
export * from "./swiper-button.vue?vue&type=script&lang=js&"
import style0 from "./swiper-button.vue?vue&type=style&index=0&id=ca58a3a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca58a3a6",
  null
  
)

export default component.exports